import React from 'react';
import { TextBadge } from '@/UIlibrary/TextBadge/TextBadge';
import { COLOR_TYPE } from '@/UIlibrary/globalTypes';
import { FincluOperationStatus } from '@/types/FincluOperationStatus';
import { useTranslations } from 'use-intl';

interface FincluStatusBadgeProps {
	status: FincluOperationStatus;
	size?: 'sm' | 'md' | 'lg';
}

export const FincluStatusBadge: React.FC<FincluStatusBadgeProps> = ({ status, size = 'sm' }) => {
	const t = useTranslations('FincluStatus');

	const statusStyles: Record<FincluOperationStatus, COLOR_TYPE> = {
		[FincluOperationStatus.IN_PROGRESS]: 'primary',
		[FincluOperationStatus.PENDING_REVIEW]: 'warning',
		[FincluOperationStatus.PENDING_CLARIFICATION]: 'warning',
		[FincluOperationStatus.APPROVED]: 'success',
		[FincluOperationStatus.REJECTED]: 'error'
	};

	const statusDisplayNames: Record<FincluOperationStatus, string> = {
		[FincluOperationStatus.IN_PROGRESS]: t('InProgress'),
		[FincluOperationStatus.PENDING_REVIEW]: t('PendingReview'),
		[FincluOperationStatus.PENDING_CLARIFICATION]: t('PendingClarification'),
		[FincluOperationStatus.APPROVED]: t('Approved'),
		[FincluOperationStatus.REJECTED]: t('Rejected')
	};

	const displayText = statusDisplayNames[status] || t('Unknown');

	return (
		<TextBadge
			text={displayText}
			size={size}
			type={statusStyles[status] || 'gray'}
			style={{ minWidth: '140px', justifyContent: 'center' }}
		/>
	);
};
